/* eslint-disable header/header */
export const name = "@azure/msal-node";
export const version = "1.0.0-beta.6";
